import { render, staticRenderFns } from "./SidebarItemForChoose.vue?vue&type=template&id=10743011&scoped=true&"
import script from "./SidebarItemForChoose.vue?vue&type=script&lang=js&"
export * from "./SidebarItemForChoose.vue?vue&type=script&lang=js&"
import style0 from "./SidebarItemForChoose.vue?vue&type=style&index=0&id=10743011&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10743011",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10743011')) {
      api.createRecord('10743011', component.options)
    } else {
      api.reload('10743011', component.options)
    }
    module.hot.accept("./SidebarItemForChoose.vue?vue&type=template&id=10743011&scoped=true&", function () {
      api.rerender('10743011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/SidebarItemForChoose.vue"
export default component.exports